import { Col, Divider, Form, Row } from 'antd';
import { FormFilter, InputForm } from 'components';
import Content from 'layouts/Content';

const spanCol = 8;

interface FilterRewardFrameProps {
  isOpen: boolean;
  onFinish: (values: any) => void;
  onCancel: () => void;
}

const FilterRewardFrame = ({
  isOpen,
  onFinish,
  onCancel,
}: FilterRewardFrameProps) => {
  const [form] = Form.useForm();
  // const [groupRoleManagementOptions, setGroupRoleManagementOptions] = useState<
  //   DefaultOptionType[]
  // >([]);

  // const {
  //   mutate: getComboboxGroupRoleManagement,
  //   isPending: isPendingGetComboboxGroupRoleManagement,
  // } = useMutation({
  //   mutationFn: CalculationSetupApis.getComboboxGroupRoleManagement,
  //   onSuccess: (data) => {
  //     const rewardIds: string[] = [];
  //     const options = (data?.data?.getGroupRoleManagement?.items || [])
  //       .filter((item: any) => {
  //         if (rewardIds.includes(item.rewardId)) return false;
  //         rewardIds.push(item.rewardId);
  //         return true;
  //       })
  //       .map((item: any) => ({
  //         ...item,
  //         id: item.rewardId,
  //       }));

  //     setGroupRoleManagementOptions(options);
  //   },
  // });

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  // useEffect(() => {
  //   getComboboxGroupRoleManagement({
  //     skip: 0,
  //     take: 100,
  //   });
  // }, [getComboboxGroupRoleManagement]);

  return (
    <>
      <Content isOpen={isOpen}>
        <FormFilter form={form} onFinish={onFinish} onCancel={handleCancel}>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col span={spanCol} className="h-[80px]">
              <Form.Item label="Mã điều kiện" name="rewardSetupId">
                <InputForm placeholder="Nhập mã điều kiện" />
              </Form.Item>
            </Col>
            {/* <Col span={spanCol} className="h-[80px]">
              <Form.Item label="Mã thưởng DMS" name="groupRoleManagement">
                <SelectForm
                  fieldNames={{
                    label: 'rewardId',
                    value: 'rewardId',
                  }}
                  placeholder="Chọn mã thưởng DMS"
                  size="large"
                  loading={isPendingGetComboboxGroupRoleManagement}
                  options={groupRoleManagementOptions}
                />
              </Form.Item>
            </Col>
            <Col span={spanCol} className="h-[80px]">
              <Form.Item label="Loại" name="typeReward">
                <SelectForm
                  options={typeRewardOptions}
                  placeholder="Chọn loại"
                />
              </Form.Item>
            </Col> */}
          </Row>
        </FormFilter>
      </Content>
      <Divider />
    </>
  );
};

export default FilterRewardFrame;
